import React from 'react';

import type { GridSlotProps } from '@mui/x-data-grid-premium';
import { AlineTooltip } from 'src/components/generic/AlineTooltip';

/**
 * The grid's `baseTooltip` slot, so the column header menu and sort buttons
 * (and every other grid tooltip) look like the rest of the app.
 */
export function GridAlineTooltip(props: GridSlotProps['baseTooltip']) {
  return <AlineTooltip arrow {...props} />;
}
